import styled from 'styled-components';

export const SWrapper = styled.div<{ hasSubHeader?: boolean }>`
  background-color: ${({ theme }) => theme.background.color.light};
  height: calc(100vh - 88px); // full height - header
  overflow: auto;
  position: relative;
`;
